
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLocationS as ObiLocationSElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-location-s.js';
 
 
 

 
 export const ObiLocationS = createComponent({
   react: React,
   tagName: 'obi-location-s',
   elementClass: ObiLocationSElement,
   events: {
     
   }
  });
 
 